import { Logo } from '@artosera/ui';
import type { JSX, ReactNode } from 'react';
import { Accrochage, type EtatAccrochage } from './Accrochage.js';
import styles from './AuthCard.module.css';

export interface AuthCardProps {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  /**
   * Le mur dessiné à côté de la carte : accroché pour les entrées, décroché
   * pour l'archive d'une galerie résiliée.
   */
  mur?: EtatAccrochage;
  /** Carte plus large, pour un contenu de fiche (archive). */
  large?: boolean;
}

/**
 * Carte commune aux écrans d'authentification (connexion, 2FA, invitation…),
 * posée à côté d'un plan d'accrochage : sur grand écran le mur occupe la
 * moitié gauche, sur téléphone il se réduit à une frise au-dessus de la carte.
 */
export function AuthCard({
  title,
  subtitle,
  children,
  footer,
  mur = 'accroche',
  large = false,
}: AuthCardProps): JSX.Element {
  return (
    <div className={styles.scene}>
      <div className={styles.mur} data-etat={mur}>
        <div className={styles.cadrage}>
          <Accrochage etat={mur} />
        </div>
      </div>
      <main className={styles.colonne}>
        <div className={[styles.carte, large ? styles.large : ''].filter(Boolean).join(' ')}>
          <Logo className={styles.logo} />
          <h1 className={styles.titre}>{title}</h1>
          {subtitle ? <p className={styles.sousTitre}>{subtitle}</p> : null}
          {children}
          {footer ? <div className={styles.pied}>{footer}</div> : null}
        </div>
      </main>
    </div>
  );
}
